const FeedQueryKeys = {
  global: ["feeds"] as const,

  list: () => [...FeedQueryKeys.global, "list"] as const,
  feed: (id: string) => [...FeedQueryKeys.global, "details", id] as const,
};

export { FeedQueryKeys };
